import {
  MessageCircle, ScanFace, Sparkles, CalendarDays, TrendingUp, BellRing,
  UserRound, Route, ShieldCheck, Timer, UserRoundX, Circle,
} from 'lucide-react';

const ICONS = { MessageCircle, ScanFace, Sparkles, CalendarDays, TrendingUp, BellRing, UserRound, Route, ShieldCheck, Timer, UserRoundX };

/** Resolve a lucide icon by name (content files store icon names as strings). */
export const iconFor = (name) => ICONS[name] || Circle;
